import { createApp } from 'vue';
import Component from './EditorJsMath.vue';

export class MathTool {
  constructor({ data }) {
    this.math = data.math;
  }

  static get toolbox() {
    return {
      title: 'Формула',
      icon: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.74455 1.00684C1.61952 3.78613 1 6.82413 1 10.0068C1 13.1895 1.61952 16.2275 2.74455 19.0068M17.5 1.00684C18.4673 3.78613 19 6.82413 19 10.0068C19 13.1895 18.4673 16.2275 17.5 19.0068M6.25 6.89145L7.6945 6.00253C8.10608 5.74925 8.64626 5.94563 8.79909 6.4041L11.2009 13.6096C11.3537 14.068 11.8939 14.2644 12.3055 14.0111L13.75 13.1222M5.5 13.8722L5.71335 13.9625C6.45981 14.2783 7.32536 14.0188 7.77495 13.3444L12.225 6.66926C12.6746 5.99487 13.5402 5.73538 14.2867 6.05119L14.5 6.14145" stroke="#ffffff" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
    };
  }

  render() {
    const wrapper = document.createElement('div');

    const app = createApp(Component, {
      math: this.math,
      onUpdate: (newValue) => {
        this.math = newValue;
      },
    });
    app.mount(wrapper);

    return wrapper;
  }

  save() {
    return {
      math: this.math,
    };
  }

  static get isReadOnlySupported() {
    return true;
  }
}
